import { Tag, Tooltip, theme } from 'antd';
import type { StatusTone } from './statusTone';

interface StatusDotTagProps {
  label: string;
  status: string;
  tone: StatusTone;
}

/** `● Ebook` — the dot colour is the status; the word for it lives in the
 * tooltip, so a row of diagnostics reads as one quiet band. `ModStatusTag`
 * is the loud sibling, for a surface where the state is the subject. */
export const StatusDotTag = ({ label, status, tone }: StatusDotTagProps) => {
  const { token } = theme.useToken();
  const color = {
    success: token.colorSuccess,
    warning: token.colorWarning,
    error: token.colorError,
  }[tone];

  return (
    <Tooltip title={`${label}: ${status}`}>
      <Tag
        style={{
          marginInlineEnd: 0,
          background: token.colorBgContainer,
          borderColor: token.colorBorder,
          color: token.colorTextSecondary,
        }}
      >
        <span
          style={{
            color,
            marginInlineEnd: token.marginXXS,
            fontSize: token.fontSizeSM - 3,
          }}
        >
          ●
        </span>
        {label}
      </Tag>
    </Tooltip>
  );
};
